import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { Section } from 'components/BusinessCard/components/StyledComponents'
import { useBusinessCard } from 'components/BusinessCard/context'
import { H6, P } from '@PipelineDeals/shared-react-components'

const Fax = ({ faxAttrs }) => {
  const { t } = useTranslation()
  const { cardMeta: { showOnlyFields }, resource } = useBusinessCard()

  const faxes = useMemo(() => {
    return faxAttrs.filter(attr => showOnlyFields.includes(attr)).map(attr => resource[attr]).filter(attr => !!attr)
  })

  if (!faxes.length) return null

  return (
    <>
      {faxes.map(fax =>
        <Section key={fax}>
          <H6>
            {t('businessCard.labels.fax')}
          </H6>
          <P>{fax}</P>
        </Section>
      )}
    </>
  )
}

Fax.propTypes = {
  faxAttrs: PropTypes.array.isRequired
}

export default Fax
